import clsx from 'clsx';
import { COLOR_ITEMS } from '../constants';
import type { Color } from '../types/CandidateBoard';

type Props = {
  colorType: Color;
  onColorSelect?: (color: Color) => void;
};

export default function CandidatesSelectColorMenu({ colorType, onColorSelect }: Props) {
  return (
    <div
      className="flex w-[150px] flex-col rounded-sm bg-white shadow-layer3"
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      role="menu"
    >
      {COLOR_ITEMS.map((i, key) => {
        return (
          <button
            type="button"
            className="flex h-xxl cursor-pointer items-center gap-xxs px-sm hover:bg-gray_darken"
            key={key}
            onClick={() => onColorSelect && onColorSelect(i.value as Color)}
          >
            <span
              className={clsx(
                'size-md rounded-sm',
                i.value === 'gray' && 'bg-gray-100',
                i.value === 'green' && 'bg-green-100',
                i.value === 'blue' && 'bg-blue-100',
                i.value === 'yellow_green' && 'bg-lime-100',
                i.value === 'yellow' && 'bg-yellow-100',
                i.value === 'orange' && 'bg-orange-100',
                i.value === 'red' && 'bg-red-100',
                i.value === 'pink' && 'bg-magenta-100',
                i.value === 'purple' && 'bg-purple-100'
              )}
            ></span>
            <p className="text-body-xs">{i.label}</p>
            {colorType === i.value && (
              <img
                src="/agent/candidates/icon-check-circle.svg"
                width={16}
                height={16}
                alt=""
                className="ml-auto"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
